export const DEFAULT_DATE = '0000-00-00 00:00:00';

export const MIN_INPUT_WIDTH = '8rem';

export const SWITCH_ITEM = {
	ID_LIST: 'idList',
	CUSTOM: 'custom',
};
